import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend) // Lazy loading des fichiers JSON
  .use(LanguageDetector) // Détecte la langue du navigateur
  .use(initReactI18next) // Hook react-i18next
  .init({
    // La langue suit TOUJOURS le navigateur (1re langue supportée) ; anglais en repli.
    fallbackLng: 'en',
    // On ne supporte que en/fr. `nonExplicitSupportedLngs` fait que les variantes
    // régionales (en-GB, en-US, fr-FR…) sont reconnues et ramenées à en/fr — sinon
    // un navigateur en-GB avec fr dans la liste basculait à tort en français.
    supportedLngs: ['en', 'fr'],
    nonExplicitSupportedLngs: true,
    // On ne charge que les fichiers de la langue de base (en/fr) — pas de 404 en-US.
    load: 'languageOnly',
    ns: ['common', 'contract'],
    defaultNS: 'common',
    fallbackNS: 'common',

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      // Uniquement le navigateur : pas de sélecteur de langue dans l'app, donc
      // localStorage ne ferait que figer une ancienne détection. On l'exclut de
      // l'ordre ET du cache pour garantir « toujours la langue du navigateur ».
      order: ['navigator'],
      caches: [],
    },

    interpolation: {
      escapeValue: false, // React handles XSS — no double-encoding of / & < > etc.
    },

    react: {
      useSuspense: true, // pour lazy loading
    },
  });

// Garde `<html lang>` synchronisé avec la langue résolue (a11y/SEO) — la valeur
// statique de index.html ne reflétait jamais la langue réelle.
const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined' && lng) {
    document.documentElement.lang = lng;
  }
};
i18n.on('languageChanged', syncHtmlLang);
i18n.on('initialized', () => syncHtmlLang(i18n.resolvedLanguage ?? i18n.language));

export default i18n;
